import { render, staticRenderFns } from "./linkDistribute.vue?vue&type=template&id=7002ce0a&scoped=true"
import script from "./linkDistribute.vue?vue&type=script&lang=js"
export * from "./linkDistribute.vue?vue&type=script&lang=js"
import style0 from "./linkDistribute.vue?vue&type=style&index=0&id=7002ce0a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7002ce0a",
  null
  
)

export default component.exports